"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonForm = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const core_1 = require("@bluebase/core");
const formik_1 = require("formik");
const react_1 = tslib_1.__importDefault(require("react"));
const Form_1 = require("./Form");
const FormFields_1 = require("./FormFields");
const FormikEffect_1 = tslib_1.__importDefault(require("./FormikEffect"));
/**
 * A component that takes a json schema and converts it into a form.
 * @param props
 */
const JsonFormInternal = (props) => {
    const { schema } = props;
    const { fields, fieldTypes } = schema, rest = tslib_1.__rest(schema, ["fields", "fieldTypes"]);
    return (react_1.default.createElement(formik_1.Formik, Object.assign({}, rest),
        react_1.default.createElement(react_1.default.Fragment, null,
            schema.onChange ? react_1.default.createElement(FormikEffect_1.default, { onChange: schema.onChange }) : null,
            react_1.default.createElement(Form_1.Form, { style: { flex: 1, display: 'flex', flexDirection: 'column' } },
                react_1.default.createElement(FormFields_1.FormFields, { fields: fields, fieldTypes: fieldTypes })))));
};
const defaultStyles = (theme) => ({
    root: {
        flexGrow: 1,
    },
    header: {
        padding: theme.spacing.unit * 2,
    },
    title: {},
    titlePadding: {
        paddingBottom: theme.spacing.unit,
    },
    description: {
        color: theme.palette.text.disabled,
    },
});
/**
 * A component that takes a json schema and converts it into a form.
 * @param props
 */
const JsonForm = (props) => {
    const { args, filter, schema, style } = props;
    const { description, fields, title } = schema, rest = tslib_1.__rest(schema, ["description", "fields", "title"]);
    const styles = core_1.useStyles('JsonForm', props, defaultStyles);
    let node = react_1.default.createElement(JsonFormInternal, Object.assign({ schema: schema }, rest));
    if (filter) {
        node = (react_1.default.createElement(components_1.BlueBaseFilter, { filter: filter, value: schema, args: args }, (filteredSchema) => {
            return react_1.default.createElement(JsonFormInternal, Object.assign({ schema: filteredSchema }, rest));
        }));
    }
    let header = null;
    if (title || description) {
        header = (react_1.default.createElement(components_1.View, { style: styles.header },
            title ? (react_1.default.createElement(components_1.FormattedMessage, { component: components_1.H6, style: [styles.title, !!description && styles.titlePadding] }, title)) : null,
            description ? (react_1.default.createElement(components_1.FormattedMessage, { component: components_1.Body2, style: styles.description }, description)) : null));
    }
    return (react_1.default.createElement(components_1.View, { style: [styles.root, style] },
        header,
        node));
};
exports.JsonForm = JsonForm;
